import globalIP from '@/GlobelIP';
import ugr from '@/UGRoute';
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Tooltip, Whisper, Table } from 'rsuite';
const { Column, HeaderCell, Cell } = Table;

export default function RevisionViewModal({ open, close, costingFor, selectedData }) {
  const [revisionData, setRevisionData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        `${globalIP}/api/costing-histories/?populate=*&filters[costingfor][$eq]=${costingFor.for}&filters[prdcd][$eq]=${selectedData.attributes.prdcd}&filters[ProductId][$eq]=${selectedData.product.id}&pagination[page]=1`
      );
      let allData = [];
      for (let page = 1; page <= data.meta.pagination.pageCount; page++) {
        const { data } = await axios.get(
          `${globalIP}/api/costing-histories/?populate=*&filters[costingfor][$eq]=${costingFor.for}&filters[prdcd][$eq]=${selectedData.attributes.prdcd}&filters[ProductId][$eq]=${selectedData.product.id}&pagination[page]=${page}`
        );
        allData.push(...data.data);
      }

      const productIds = allData.map(item => item.attributes.ProductId);
      const allProductData = await Promise.all(
        productIds.map(async id => {
          const productData = await axios.get(`${globalIP}/api/products/${id}?populate=*`);
          return productData.data.data;
        })
      );
      const mergedData = allData.map(item => {
        const product = allProductData.find(product => product.id == item.attributes.ProductId);
        return { ...item, product };
      });
      const againGenerate = mergedData.map(item => {
        const {
          CostingMaterial_his,
          CostingWood_his,
          CostingProcess_his,
          CostingAccessory_his,
          Costingpacking_his,
          ...attributesWithout
        } = item.attributes;

        return {
          ...item,
          attributes: {
            ...attributesWithout,
            CostingMaterial: item.attributes.CostingMaterial_his,
            CostingWood: item.attributes.CostingWood_his,
            CostingProcess: item.attributes.CostingProcess_his,
            CostingAccessory: item.attributes.CostingAccessory_his,
            Costingpacking: item.attributes.Costingpacking_his
          }
        };
      });
      setRevisionData(againGenerate);
    };
    fetchData();
  }, [open]);
  const columns = useMemo(
    () =>
      [
        {
          key: 'Image',
          label: 'Image',
          width: 100,
          fixed:true,
          renderCell: ({ product }) => {
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${product.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${globalIP}${product.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px', borderRadius: '50px' }}
                />
              </Whisper>
            );
          }
        },
        {
          label: 'AliasCode',
          key: 'AliasCode',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.ProductId;
          }
        },
        {
          label: 'Description',
          key: 'Description',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.Description;
          }
        },
        {
          label: 'Product Name',
          key: 'ProductName',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.ProductName;
          }
        },
        {
          label: 'Dimension',
          key: 'Dimension',
          fixed: false,
          width: 150,
          renderCell: ({ product }) => {
            return `${product.attributes.Length} x ${product.attributes.Width} x ${product.attributes.Height} ${product.attributes.SizeUnit}`;
          }
        },
        {
          label: 'Category Name',
          key: 'CategoryName',
          fixed: false,
          width: 160,
          renderCell: ({ product }) => {
            return product?.attributes?.CategoryName;
          }
        },
        {
          label: 'FinishName',
          key: 'FinishName',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.FinishName;
          }
        },
        {
          label: 'ProductType Name',
          key: 'ProductTypeName',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.ProductTypeName;
          }
        },
        {
          label: 'CBM',
          key: 'CBM',
          fixed: false,
          renderCell: ({ product }) => {
            return product?.attributes?.cbm;
          }
        },
        {
          label: 'INR',
          key: 'targetCost',
          fixed: false,
          renderCell: ({ attributes }) => {
            return attributes?.targetCost;
          }
        },
        {
          label: 'USD',
          key: 'targetCost',
          fixed: false,
          renderCell: ({ attributes }) => {
            return attributes?.targetcostUSD;
          }
        },
        {
          label: 'Revision No.',
          key: 'Revisionno',
          fixed: false,
          width: 100,
          renderCell: ({ attributes }) => {
            return attributes?.RevisionNo;
          }
        },
        costingFor.for == 'buyer' && {
          label: 'Buyer Name',
          key: 'buyerName',
          fixed: false,
          width: 100,
          renderCell: ({ attributes }) => {
            return attributes?.buyername;
          }
        },
        {
          label: 'Action',
          key: 'action',
          fixed: false,
          renderCell: ({ product, attributes, id }) => {
            return costingFor.for == 'factory' ? (
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <Button
                  size="sm"
                  onClick={() =>
                    navigate(`/${ugr}/costing`, {
                      state: {
                        ...product,
                        costingFor,
                        isEdit: false,
                        fetchRevision: true,
                        revisionId: id,
                        revisionData: attributes
                      }
                    })
                  }
                >
                  View
                </Button>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <Button
                  size="sm"
                  onClick={() =>
                    navigate(`/${ugr}/costing`, {
                      state: {
                        ...product,
                        costingFor: { for: 'buyer', name: attributes.buyername },
                        isEdit: false,
                        fetchRevision: true,
                        revisionId: id,
                        revisionData: attributes
                      }
                    })
                  }
                >
                  View
                </Button>
              </div>
            );
          }
        }
      ].filter(Boolean),
    [costingFor.for]
  );
  return (
    <Modal backdrop={'static'} keyboard={false} open={open} onClose={close} size="full">
      <Modal.Header>
        <Modal.Title>Revisions</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table bordered cellBordered autoHeight data={revisionData} virtualized>
          {columns.map(({ fixed, label, key, renderCell, width }) => {
            return (
              <Column
                fixed={fixed}
                key={key}
                // flexGrow={label == 'Image' ? null : 1}
                width={width}
                align="center"
              >
                <HeaderCell
                  style={{
                    fontSize: '11px',
                    fontWeight: 'bold'
                  }}
                >
                  {label}
                </HeaderCell>
                <Cell dataKey={key}>
                  {rowData => (renderCell ? renderCell(rowData) : rowData[key])}
                </Cell>
              </Column>
            );
          })}
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={close} appearance="primary">
          Ok
        </Button>
        <Button onClick={close} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
